/* Wrapper func for setting default values */
export const createPageEntry = (id, { nav = true, banner = true, pageNav = true, sitemap = true, ...data }) => ({ [id]: { id, nav, banner, pageNav, sitemap, href: getHrefFromId(id), ...data }})

const getHrefFromId = (id) => {
  if (id === 'home') return '/'
  return `/${id}/`
}

/* To each pageData entry, add 
  1) link data for prev and next
  2) isolate anchors
*/
const addNavDetails = (data) => {
  Object.keys(data)
    .map((key) => {
      data[key].anchors = data[key].children?.filter((child) => child.href.includes('#')).map((child) => child.href.split('#')[1])
      return key
    })
    .filter((key) => data[key].pageNav)
    .forEach((key, index, keys) => {
      if (index > 0) data[key].prev = { href: getHrefFromId(keys[index - 1]), display: data[keys[index - 1]].display }
      const nextIndex = index < keys.length - 1 ? index + 1 : 0
      data[key].next = { href: getHrefFromId(keys[nextIndex]), display: data[keys[nextIndex]].display }
    })

  return data
}

/* Transforms siteData into an array consumable by the navigation components */
const createNavArray = (data) => {
  return Object.entries(data).filter(([, value]) => value.nav).map(([key, value]) => ({
    href: getHrefFromId(key),
    display: value.display,
    children: value.children,
    className: value.className,
    component: value.component,
  }))
}

/* Crate pageData and nav from config */
export const parseSiteData = (data) => {
  const pageData = addNavDetails(data)
  const nav = createNavArray(pageData)

  return { pageData, nav }
}